import { makeMutation } from '../types';
import { PlatformsBackend } from '@core/models';

type Input = { email: string; platform: PlatformsBackend };
type Output = { disconnectPlatformOfUser: boolean };

export const disconnectPlatformOfUser = makeMutation<Output, Input>(`
mutation DisconnectPlatformOfUser($email: String!, $platform: Platform!) {
  ayn {
    disconnectPlatformOfUser(email: $email, platform: $platform)
  }
}

`);
